<template>
    <div :style="getStyle" class="bg-white" id="occupationskillsModifiedByUserCard">
        <vx-card>
            <h2 class="mb-2">Mes savoir-faire modifiés</h2>
            <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
                    <DialogPrompt
                        :active.sync="showPopup"
                        title="Consulter un savoir-faire"
                        cancel-text="Fermer"
                        accept-text="Enregistrer"
                        button-accept="false"
                    >
                        <OccupationSkillForm v-model="resource" type="show" />
                    </DialogPrompt>
                    <vs-table
                        :sst="true"
                        no-data-text="Aucune donnée à afficher"
                        style="width: 100%"
                        :data="occupationSkills"
                    >
                        <template slot="thead">
                            <vs-th></vs-th>
                            <vs-th>Savoir-faire</vs-th>
                            <vs-th>Filière</vs-th>
                            <vs-th>Modifié le</vs-th>
                        </template>

                        <template slot-scope="{ data }">
                            <vs-tr v-for="(item, i) in occupationSkills" :key="i" :data="item">
                                <vs-td>
                                    <feather-icon icon="ApertureIcon" class="" />
                                </vs-td>
                                <vs-td
                                    v-tooltip="{
                                        content: item.description,
                                        placement: 'top-start',
                                        classes: ['occ-description'],
                                    }"
                                >
                                    <p @click="showResource(item)">{{ get(item, ":title") }}</p>
                                </vs-td>
                                <vs-td>
                                    <p @click="showResource(item)">{{ get(item, ":sector.title") }}</p>
                                </vs-td>
                                <vs-td>
                                    <p @click="showResource(item)">{{ get(item, ":updated_at") }}</p>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </vs-col>
            </vs-row>
            <vs-row>
                <vs-col class="text-right mt-2">
                    <a href="/rh/referentiel/savoir-faire">Voir plus...</a>
                </vs-col>
            </vs-row>
        </vx-card>
    </div>
</template>
<script>
import OccupationSkillForm from "@components/views/rh/referentiel/occupation-skill/OccupationSkillForm";
export default {
    components: {
        OccupationSkillForm,
    },
    data() {
        return {
            occupationSkills: "",
            showPopup: false,
            resource: {},
        };
    },
    computed: {
        getStyle() {
            return "height: 100%; background-size: contain; background-repeat: no-repeat; border: 2px solid #FCE4EC; border-radius: 5px; background-position: center;";
        },
    },
    created() {
        this.loadOccupationSkills();
    },
    methods: {
        showResource(resource) {
            this.resetResource();
            this.setResource(resource);
            this.showPopup = true;
        },
        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },
        resetResource() {
            this.resource = {
                title: null,
                description: null,
                sector: null,
                skills: {},
            };
        },
        loadOccupationSkills() {
            window
                .axios({
                    method: "get",
                    url: "/api/referentiel/occupation-skills",
                    params: {
                        perpage: 4,
                        sortBy: { updated_at: "desc" },
                        include: ["sector", "skills"],
                        filter: "updated_by:" + this.user.id,
                    },
                })
                .then((response) => {
                    response.data.data.forEach((element) => {
                        element["updated_at"] = new Date(element["updated_at"]).toLocaleString("fr-FR");
                    });

                    this.occupationSkills = response.data.data;
                })
                .catch((err) => {
                    console.log(err);
                    this.notifyError(err, `Une erreur est survenue`);
                });
        },
    },
};
</script>
